var $f467c0ee7bfb0950$exports = {};
$f467c0ee7bfb0950$exports = {
  "breadcrumbs": "Migas de pan"
};
export { $f467c0ee7bfb0950$exports as default };